/*global $*/
/*eslint no-undef: "error"*/
export default class NumberItem {
    classButton = 'number-item--item'
    classOpen = 'number-item---active'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            $(this).toggleClass(self.classOpen)
        })
    }
}
